import DOMPurify from 'dompurify'
import { node_url } from 'src/helpers'

const escapeHtml = (text) =>
    text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

// Plain text (blank line = new paragraph) becomes paragraphs; HTML is sanitized and passed through.
export function renderBody(body) {
    const text = body || ''
    if (/<\/?[a-z][\s\S]*>/i.test(text)) return DOMPurify.sanitize(text)
    return text
        .split(/\n\s*\n/)
        .map((block) => block.trim())
        .filter(Boolean)
        .map((block) => `<p>${escapeHtml(block).replace(/\n/g, '<br/>')}</p>`)
        .join('')
}

export function timeAgo(dateValue) {
    const seconds = Math.floor((Date.now() - new Date(dateValue).getTime()) / 1000)
    if (isNaN(seconds) || seconds < 0) return ''
    const units = [['year', 31536000], ['month', 2592000], ['week', 604800], ['day', 86400], ['hour', 3600], ['minute', 60]]
    for (const [name, size] of units) {
        const count = Math.floor(seconds / size)
        if (count >= 1) return `${count} ${name}${count > 1 ? 's' : ''} ago`
    }
    return 'just now'
}

export function formatExperience(value) {
    const text = (value || '').toString().trim()
    if (!text) return ''
    return /^[\d.]+$/.test(text) ? `${text} ${text === '1' ? 'yr' : 'yrs'}` : text
}

// Uploaded images are stored as relative paths; older content may hold a full URL.
export function resolveImageUrl(value) {
    const text = (value || '').trim()
    if (!text) return ''
    if (/^(https?:)?\/\/|^data:/i.test(text)) return text
    return node_url + text.replace(/^\/+/, '')
}
